module.exports = __webpack_public_path__ + "img/ranking_top3_big.9d23aca0.webp";